import * as React from 'react';
import { Link } from '@cian/link-component';

export type TDealType = 'rent' | 'sale';

export interface IInactiveAnnouncementsLinkProps {
  dealType: TDealType;
  target?: string;
}

export const InactiveAnnouncementsLink: React.FC<IInactiveAnnouncementsLinkProps> = props => {
  const userId = window.__header_user_id__;
  const dealTypeNumber = props.dealType === 'rent' ? 1 : 2;

  const href = `http://my.cian.ru/cat.php?id_user=${userId}&deal_type=${dealTypeNumber}&b=1`;

  return (
    <Link href={href} target={props.target}>
      {props.children}
    </Link>
  );
};
